import { useEffect } from 'react';
import { useToast } from '@/contexts/ToastContext';
import { setApiErrorHandler, getFriendlyErrorMessage } from '@/lib/api-error';

/**
 * Wires the React toast system into the non-React API error layer so any failed
 * API call — mutations (via the query client's MutationCache) or imperative
 * notifyApiError() calls (downloads, exports) — surfaces a friendly,
 * screenshot-able toast with a support reference code. Renders nothing.
 */
export function ApiErrorBridge() {
  const { addToast } = useToast();

  useEffect(() => {
    setApiErrorHandler((error) => {
      addToast({
        type: 'error',
        title: 'Something went wrong',
        message: getFriendlyErrorMessage(error),
        duration: 8000,
      });
    });
    return () => setApiErrorHandler(null);
  }, [addToast]);

  return null;
}
